import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'vb-widgets-general-24',
  templateUrl: './24.component.html',
})
export class VbGeneral24Component implements OnInit {
  constructor() {}
  ngOnInit() {}
}
